import React from 'react';
import { FaPlay } from 'react-icons/fa';
import './RestaurantProcess.css';

const RestaurantProcess = () => {
  return (
    <section className="restaurant-process">
      <div className="process-container">
        {/* Left Side - Image */}
        <div className="process-image-side">
          <img 
            src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&q=80" 
            alt="Food Process" 
            className="process-food-image"
          />
        </div>

        {/* Right Side - Content */}
        <div className="process-content-side">
          <span className="process-label">Restaurant Active Process</span>
          <h2 className="process-title">
            <span className="process-title-white">We</span> Document Every Food
            <br />
            Bean Process untile it is saved
          </h2>
          <p className="process-description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque diam pellentesque 
            bibendum non dui volutpat fringilla bibendum. Urna, elit augue urna,
          </p>

          <div className="process-buttons">
            <button className="process-btn read-more-btn">
              Read More
            </button>
            <button className="process-btn play-video-btn">
              <span className="play-icon-wrapper">
                <FaPlay className="play-icon" />
              </span>
              <span>Play Video</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RestaurantProcess;
